import AnimationManager from "./classes/AnimationManager";
import MenuManager from "./classes/MenuManager";
import InstagramFeed from "./classes/InstagramFeed";
import PageTransition from './scripts/PageTransition';
import Barba from 'barba.js';
import ContactForm from './classes/ContactForm';
import {mobileVideoRatio} from "./scripts/setVideoRatio";
import TweenLite from 'gsap'
import CiscoView from './Views/CiscoView'

let manager = null;
let menu = MenuManager.setup();
if( window.matchMedia( '( min-width: 576px )' ).matches ) {
    manager = new AnimationManager();
}
let formsContainer = {};

Barba.cisco = null;

Barba.Pjax.Dom.putContainer = function (element) {
    element.style.display = 'none';

    let wrapper = this.getWrapper();
    wrapper.appendChild(element);
}

Barba.Dispatcher.on('initStateChange', function() {
    // modify to your needs
    gtag('config', 'UA-67725005-1', {
        'anonymize_ip': true,
        'page_title': document.title,
        'page_path': (window.location.href).replace(window.location.origin, '').toLowerCase()
    });
});

Barba.Dispatcher.on('newPageReady', (currentStatus, prevStatus, container, newPage) => {
    let parser = new DOMParser();
    let page = parser.parseFromString(newPage, "text/html");
    document.body.id = page.body.id;
    document.body.classList = page.body.classList;
});

Barba.Dispatcher.on('transitionCompleted', (currentStatus, prevStatus) => {
    if (document.querySelector('.insta-grid .item')) {
        new InstagramFeed();
    }

    let forms = document.querySelectorAll('.db-forms')

    if( document.querySelector('.mobile-home .responsive-video') && window.matchMedia( '( max-width: 577px )' ).matches) {
        mobileVideoRatio();
        document.querySelectorAll('.mobile-home .intro-section').forEach( el => el.style.height = window.innerHeight+'px' );
        TweenLite.to( document.querySelector('.mobile-home .intro-section .background .mask'), 1, { rotationZ: 65, onComplete() {
            TweenLite.to( document.querySelector('.mobile-home .intro-section .inner.content'), .5, {
                y: 0,
                opacity: 1
            } )
        } } )
    }

    if (forms.length) {
        forms.forEach(el => {
            if( formsContainer[el.id] === undefined ) {
                formsContainer[el.id] = new ContactForm(el);
            }
        })
    }
});

Barba.Pjax.getTransition = () => {
    return PageTransition;
};
CiscoView.init();
Barba.Pjax.start();

export {
    manager,
    menu
};